import {
  LOAD_PIXEL_SERVER
} from 'constants/reduxActions';

export default function pixelServerReducer(state = {}, action) {
  const { type, pageType, pageId, pageLang, trackingPayload, queryString } = action;
  switch (type) {
    case LOAD_PIXEL_SERVER:
      // the page ID here is used to "cache bust" for pixel pages with no parameters and the same pageType (e.g landing pages).
      return {
        data: {
          pageId,
          trackingPayload
        },
        pageType,
        pageLang,
        queryString
      };
    default:
      return state;
  }
}
